import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
const Layout = ({ children, currentPath, hideHeader }) => {
    return (React.createElement(React.Fragment, null,
        !hideHeader && React.createElement(Header, { currentPath: currentPath }),
        React.createElement("main", null, children),
        React.createElement(Footer, null)));
};
export default Layout;
